import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SettingsIcon } from '../../../assets/images/appicons/appicon-settings.svg';
import { ReactComponent as Arrow } from '../../../assets/images/arrow_suggestion.svg';
import { reveal } from '../../shared/keyframe-animations';
import { Photo } from '../../shared/Photo';

export const ImageAppSettings: React.FC = () => {
  const { i18n } = useTranslation();
  const srcSet = `/images/settings/img_setting_hint_${i18n.language}-2x.png 2x, /images/settings/img_setting_hint_${i18n.language}.png 1x`;
  return (
    <div
      className={css`
        width: 224px;
        height: 145px;
        margin: auto;
        position: relative;
        transform: translate(20px, 16px);
        .photo {
          width: 100%;
          height: 100%;
          transform: rotate(2deg);
        }
        .bf-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 96px;
          height: 96px;
          background-color: #a38950;
          border-radius: 36%;
          box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
          position: absolute;
          top: -40px;
          left: -56px;
          transform: rotate(-6deg);
          z-index: 1;
        }
        .arrow {
          position: absolute;
          top: -8px;
          left: 40px;
          transform: scaleY(-1);
          @media (prefers-reduced-motion: no-preference) {
            svg {
              transform: translateY(-4px);
              animation: ${reveal} 0.4s ease-in-out infinite alternate;
            }
          }
        }
        /* less than iPhone6/7/8 display size */
        @media screen and (max-width: 374px) {
          width: 192px;
          height: 124px;
          .bf-icon {
            width: 72px;
            height: 72px;
            top: -20px;
            left: -44px;
          }
          .arrow {
            top: -16px;
            left: 32px;
          }
        }
      `}
    >
      <div className="bf-icon">
        <SettingsIcon width="100%" height="100%" />
      </div>
      <div className="photo">
        <Photo srcSet={srcSet} />
      </div>
      <div className="arrow">
        <Arrow />
      </div>
    </div>
  );
};
